// extracted by mini-css-extract-plugin
export default {"ssoBanner":"UserSSOBanner_ssoBanner__RkBIr","content":"UserSSOBanner_content__mZFyE","buttonBar":"UserSSOBanner_buttonBar__cowNh","closeButton":"UserSSOBanner_closeButton__m+6Ag"};